import { strText } from "../constants";
import { pagesText } from "../constants/english";
import { formatNumber, getCurrencySymbol } from "./helpers";
import { convertDateTime, getLetterHistoryUserName } from "../utils/lib";
// import Popper from "popper.js";

const $ = require('jquery') // 1
// $.DataTable  = require( 'datatables.net')
$.DataTable = require('datatables.net-dt') //2
$.DataTable = require('datatables.net-responsive-dt') //3
$.Database = require('datatables.net-responsive-dt/css/responsive.dataTables.css') //3
//
$.DataTable = require("datatables.net-buttons/js/buttons.html5.js") // 4:: loads the copy,pdf,csv buttons and makes it works
$.DataTable = require("datatables.net-buttons/js/buttons.print.js") // 4::loads the print btn and makes it work
//
$.DataTable = require('datatables.net-bs5'); //5

//user admin  table_user_management
// export const TransfereeCerticatesDatatable = (data, setItems, currencies) => {
//     const cols = [

//         {data: 'CERTIFICATE_NUMBER'},

//         {data: 'CERTIFICATE_DATE'},

//         // {data: 'CURRENCY'},
        
//         // {data: 'AMOUNT_REQUEST'},
//         {
//             data: (a) => {
//                 let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                 let amountRequested = Number(a?.AMOUNT_REQUEST)?.toLocaleString(
//                                 'en-US', {
//                                     minimumFractionDigits: 2,
//                                     maximumFractionDigits: 2
//                                     }
//                               )
//                 return `${currencySymbol}${amountRequested}`
//             }
//         },
//         {
//             data: (a) => {
//                 if(a?.APPROVED_AMOUNT_FOR_DISTURBED){
//                     let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                     let amountAvailable = Number(a?.APPROVED_AMOUNT_FOR_DISTURBED)?.toLocaleString(
//                                     'en-US', {
//                                         minimumFractionDigits: 2,
//                                         maximumFractionDigits: 2
//                                         }
//                                 )
//                     return `${currencySymbol}${amountAvailable}`
//                 } else{
//                     return ''
//                 }    
//             }
//         },
//         {
//             data: (a) => {
//             return a?.WHT_RATE_PERCENTAGE ? `${a?.WHT_RATE_PERCENTAGE}%` : '' 
                
//             }
//         },

//         // {data: 'AMOUNT_AVAILABLE'},
//         {
//             data: (a) => {
//                 if(a?.AMOUNT_AVAILABLE){
//                     let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                     let amountAvailable = Number(a?.AMOUNT_AVAILABLE)?.toLocaleString(
//                                     'en-US', {
//                                         minimumFractionDigits: 2,
//                                         maximumFractionDigits: 2
//                                         }
//                                 )
//                     return `${currencySymbol}${amountAvailable}`
//                 } else{
//                     return ''
//                 }    
//             }
//         },
//         {
//             data: (a) => {
//                 if(a?.AMOUNT_AVAILABLE){
//                     let balance = a?.APPROVED_AMOUNT_FOR_DISTURBED - a?.AMOUNT_AVAILABLE
//                     let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                     let formatted = formatNumber(balance)
//                     return `${currencySymbol}${formatted}`  
//                     }else{
//                         return ''
//                     } 
//             }
//         },

//         // {data: 'ADDITIONAL_DETAILS'},

//         {
//             data: (a) => {
//                 return a?.CERTIFICATE_STATUS == 'pending' ? `
//                 <div class="badge badge-pill text-white text-capitalize badge-warning">
//                     ${a?.CERTIFICATE_STATUS}
//                 </div>` :  
//                 a?.CERTIFICATE_STATUS == 'approved' ?  `
//                 <div class="badge badge-pill text-white text-capitalize badge-info">
//                     ${a?.CERTIFICATE_STATUS}
//                 </div>` :  
//                 a?.CERTIFICATE_STATUS == 'disapproved' ?  `
//                 <div class="badge badge-pill text-white text-capitalize badge-danger">
//                     ${a?.CERTIFICATE_STATUS}
//                 </div>` :a?.CERTIFICATE_STATUS == 'confirmed' ?
//                 `<div class="badge badge-pill text-white text-capitalize badge-orange">
//                         ${a?.CERTIFICATE_STATUS}
//                     </div>`:
//                      `<div class="badge badge-pill text-white text-capitalize badge-success">
//                         ${a?.CERTIFICATE_STATUS}
//                     </div>`
//             }
//         },
//         {
//             data: (a) => {
//                 return moment(a?.CREATED_AT).format(pagesText.full_date)
//             }
//         },
//         {
//            data: (a) => {
//                 return `
//                         <a style="cursor: pointer" data-id=${a?.ID} class="btn-sm btn-primary certificate-view-details">View Details</a>
//                         `
//             },
//             responsivePriority: 2
//         }
//     ]

//     generalDatatableConfig(data, 'certificatesTable', cols, 'certificates', [0, 1, 2, 3, 4,5], [4, 'desc'],'Certificates')

//     $(document).on("click", ".certificate-view-details", function () {
//         const r = $(this).attr("data-id")
//         let x = data.filter((item) => Number(item?.ID) === Number(r))
//         if (x.length > 0) {
//             setItems(x[0], 'view-details')
//         }
//     })

// }

export const certicatesDatatable = (data, setItems, currencies, tableId, type='normal') => {
    const cols = [

        {data: 'CERTIFICATE_NUMBER'},

        {data: 'CERTIFICATE_NUMBER_TWO'},

        // {data: 'CERTIFICATE_DATE'},

        // {data: 'EXPIRY_DATE'},

        // {data: 'EFFECTIVE_DATE'},
        
        // {data: 'AMOUNT_REQUEST'},
        {
            data: (a) => {
                let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
                let amountOnCertificate = Number(a?.AMOUNT_ON_CERTIFICATE)?.toLocaleString(
                                'en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                    }
                              )
                return `${currencySymbol}${amountOnCertificate}`
            }
        },
        {
            data: (a) => {
                let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
                let amountRequested = Number(a?.AMOUNT_REQUEST)?.toLocaleString(
                                'en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                    }
                              )
                return `${currencySymbol}${amountRequested}`
            }
        },

        {
            data: (a) => {
                if(a?.APPROVED_AMOUNT_FOR_DISTURBED){
                    let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
                    let amountAvailable = Number(a?.APPROVED_AMOUNT_FOR_DISTURBED)?.toLocaleString(
                                    'en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                        }
                                )
                    return `${currencySymbol}${amountAvailable}`
                } else{
                    return 'N/A'
                }    
            }
        },

        {
            data: (a) => {
            return a?.WHT_RATE_PERCENTAGE ? `${a?.WHT_RATE_PERCENTAGE}%` : 'N/A' 
                
            }
        },

        // {data: 'AMOUNT_AVAILABLE'},
        {
            data: (a) => {
                if(a?.AMOUNT_AVAILABLE){
                    let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
                    let amountAvailable = Number(a?.AMOUNT_AVAILABLE)?.toLocaleString(
                                    'en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                        }
                                )
                    return `${currencySymbol}${amountAvailable}`
                } else{
                    return 'N/A'
                }    
            }
        },
        {
            data: (a) => {
                if(a?.AMOUNT_AVAILABLE){
                    let balance = a?.CERTIFICATE_BALANCE
                    let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
                    let formatted = formatNumber(balance)
                    return `${currencySymbol}${formatted}`  
                    }else{
                        return 'N/A'
                    } 
            }
        },

         {
            data: (a) => {
                if(a?.SWIFT_NUMBER){
                    return a?.SWIFT_NUMBER 
                    }else{
                        return 'N/A'
                    } 
            }
        },

        {data: 'CERTIFICATE_DATE'},

        {data: 'EXPIRY_DATE'},

        {data: 'EFFECTIVE_DATE'},

        {
            data: (a) => {
                return a?.CERTIFICATE_STATUS == 'pending' ? `
                <div class="badge badge-pill text-white text-capitalize badge-warning">
                    ${a?.CERTIFICATE_STATUS}
                </div>` :  
                a?.CERTIFICATE_STATUS == 'approved' ?  `
                <div class="badge badge-pill text-white text-capitalize badge-info">
                    ${a?.CERTIFICATE_STATUS}
                </div>` :  
                a?.CERTIFICATE_STATUS == 'disapproved' ?  `
                <div class="badge badge-pill text-white text-capitalize badge-danger">
                    ${a?.CERTIFICATE_STATUS}
                </div>` :a?.CERTIFICATE_STATUS == 'confirmed' ?
                `<div class="badge badge-pill text-white text-capitalize badge-orange">
                        ${a?.CERTIFICATE_STATUS}
                    </div>` :a?.CERTIFICATE_STATUS == 'disbursed' ?
                `<div class="badge badge-pill text-white text-capitalize badge-success">
                        ${a?.CERTIFICATE_STATUS}
                    </div>` :
                     `<div class="badge badge-pill text-white text-capitalize badge-danger">
                        ${a?.CERTIFICATE_STATUS}
                    </div>`
            },
            responsivePriority: 2
        },
        {data: 'CURRENCY'},
        
        {
            data: (a) => {
                return convertDateTime(a.CREATED_AT, pagesText.full_date)
            }
        },
        // {
        //     data: (a) => {
        //         return `
        //                 <a style="cursor: pointer" data-id=${a?.ID} class="btn-sm btn-primary certificate-view-details">View Details</a>
        //                 `
        //     },
        //     responsivePriority: 2
        // }
        {
            data: (a) => {
                return ( 
                    type == 'notap' ? (
                     `
                        <a style="cursor: pointer" data-id=${a?.ID} class="btn-sm btn-primary certificate-view-details">View Details</a>
                        <a style="cursor: pointer" data-id=${a?.ID} class="btn-sm btn-primary certificate-eval-history">View Evaluation History</a>
                        `
                    ) : (
                        `
                        <a style="cursor: pointer" data-id=${a?.ID} class="btn-sm btn-primary certificate-view-details">View Details</a>
                        `
                    ) 
                )    
            },
            responsivePriority: 2
        }
    ]

    generalDatatableConfig(data, tableId, cols, 'certificates', [0, 1, 2, 3, 4,5], [4, 'desc'],'Certificates')

    // $(document).on("click", ".dropdown", function () {
    //     const r = $(this).attr("data-toggle")
    //     let x = data.filter((item) => Number(item.user_id) === Number(r))
    //     if (x.length > 0) {
    //         setItems(x[0])
    //     }
    // })

    $(document).on("click", ".certificate-view-details", function () {
        const r = $(this).attr("data-id")
        let x = data.filter((item) => Number(item?.ID) === Number(r))
        if (x.length > 0) {
            setItems(x[0], 'view-details')
        }
    })

    $(document).on("click", ".certificate-eval-history", function () {
        const r = $(this).attr("data-id")
        let x = data.filter((item) => Number(item?.ID) === Number(r))
        if (x.length > 0) {
            setItems(x[0], 'eval-history')
        }
    })
}

export const evaluationDatatable = (data, setItems, shouldShow, userEmail, certStatus) => {
    const cols = [
         {
            data:  (a) =>{
                return `
                <button data-id=${a?.ID} class='p-0 text-primary evaluation-view-details'>
                    <i style="font-size: 1.2rem;" class="mdi mdi-plus-circle mr-1"></i>
                </button>`
            }
        },

        {
            data: 'USER_ROLE_TEXT'
        },

        {data: 'SENDER_NAME'},

        // {data: 'COMMENTS'},
        {
            data:  (a) =>{
                if(a?.COMMENTS && a?.COMMENTS != '<p><br></p>' && a?.COMMENTS != ''){
                    return `
                    <div class='text-wrap'>
                    ${a?.COMMENTS}
                    </div>`
                }else{
                    return 'N/A'
                }
            }
        },
        {
            data: (a) => {
                return convertDateTime(a.CREATED_AT, pagesText.full_date)
            }
        },
        {
            data: (a) => {
                return ( 
                    shouldShow && (userEmail == a?.SENDER_ID) && (a?.STATUS).toLowerCase() == 'draft' && certStatus == 'pending'? (
                     `
                        <a style="cursor: pointer" data-id=${a?.ID} class="btn-sm btn-primary certificate-edit-eval">Edit Evaluation</a>
                        <a style="cursor: pointer" data-id=${a?.ID} class="btn-sm btn-primary certificate-send-eval">Send</a>
                        `
                    ) : (
                        `
                        N/A
                        `
                    ) 
                )    
            },
            responsivePriority: 2
        }
    ]

    generalDatatableConfig(data, 'evaluationTable', cols, 'Evaluation', [0, 1, 2], [0, 'desc'],'Evaluation')

    // $(document).on("click", ".dropdown", function () {
    //     const r = $(this).attr("data-toggle")
    //     let x = data.filter((item) => Number(item.user_id) === Number(r))
    //     if (x.length > 0) {
    //         setItems(x[0])
    //     }
    // })

    $(document).on("click", ".certificate-edit-eval", function () {
        const r = $(this).attr("data-id")
        let x = data.filter((item) => Number(item?.ID) === Number(r))
        if (x.length > 0) {
            setItems(x[0], 'edit-eval')
        }
    })

    $(document).on("click", ".certificate-send-eval", function () {
        const r = $(this).attr("data-id")
        let x = data.filter((item) => Number(item?.ID) === Number(r))
        if (x.length > 0) {
            setItems(x[0], 'send-eval')
        }
    })

    $(document).on("click", ".evaluation-view-details", function () {
        const r = $(this).attr("data-id")
        let x = data.filter((item) => Number(item?.ID) === Number(r))
        if (x.length > 0) {
            setItems(x[0], 'eval-details')
        }
    })
}

export const previousEvaluationDatatable = (data, setItems) => {
    const cols = [
         {
            data:  (a) =>{
                return `
                <button data-id=${a?.ID} class='p-0 text-primary prev-evaluation-view-details'>
                    <i style="font-size: 1.2rem;" class="mdi mdi-plus-circle mr-1"></i>
                </button>`
            }
        },

        {
            data: 'USER_ROLE_TEXT'
        },

        {data: 'SENDER_NAME'},

        // {data: 'COMMENTS'},
        {
            data:  (a) =>{
                if(a?.COMMENTS && a?.COMMENTS != '<p><br></p>' && a?.COMMENTS != ''){
                    return `
                    <div class='text-wrap'>
                    ${a?.COMMENTS}
                    </div>`
                }else{
                    return 'N/A'
                }
            }
        },
        {
            data: (a) => {
                return convertDateTime(a.CREATED_AT, pagesText.full_date)
            }
        },
    ]

    generalDatatableConfig(data, 'prevEvaluationTable', cols, 'Evaluation', [0, 1, 2], [0, 'desc'],'Evaluation')

    $(document).on("click", ".prev-evaluation-view-details", function () {
        const r = $(this).attr("data-id")
        let x = data.filter((item) => Number(item?.ID) === Number(r))
        if (x.length > 0) {
            setItems(x[0], 'eval-details')
        }
    })
}

// export const NotapCerticatesDatatable = (data, setItems, currencies) => {
//     const cols = [

//         {data: 'CERTIFICATE_NUMBER'},

//         {data: 'CERTIFICATE_DATE'},

//         // {data: 'CURRENCY'},
        
//         // {data: 'AMOUNT_REQUEST'},
//         {
//             data: (a) => {
//                 let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                 let amountRequested = Number(a?.AMOUNT_REQUEST)?.toLocaleString(
//                                 'en-US', {
//                                     minimumFractionDigits: 2,
//                                     maximumFractionDigits: 2
//                                     }
//                               )
//                 return `${currencySymbol}${amountRequested}`
//             }
//         },

//         {
//             data: (a) => {
//                 if(a?.APPROVED_AMOUNT_FOR_DISTURBED){
//                     let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                     let amountAvailable = Number(a?.APPROVED_AMOUNT_FOR_DISTURBED)?.toLocaleString(
//                                     'en-US', {
//                                         minimumFractionDigits: 2,
//                                         maximumFractionDigits: 2
//                                         }
//                                 )
//                     return `${currencySymbol}${amountAvailable}`
//                 } else{
//                     return ''
//                 }    
//             }
//         },

//         {
//             data: (a) => {
//             return a?.WHT_RATE_PERCENTAGE ? `${a?.WHT_RATE_PERCENTAGE}%` : '' 
                
//             }
//         },

//         // {data: 'AMOUNT_AVAILABLE'},
//         {
//             data: (a) => {
//                 if(a?.AMOUNT_AVAILABLE){
//                     let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                     let amountAvailable = Number(a?.AMOUNT_AVAILABLE)?.toLocaleString(
//                                     'en-US', {
//                                         minimumFractionDigits: 2,
//                                         maximumFractionDigits: 2
//                                         }
//                                 )
//                     return `${currencySymbol}${amountAvailable}`
//                 } else{
//                     return ''
//                 }    
//             }
//         },
//         {
//             data: (a) => {
//                 if(a?.AMOUNT_AVAILABLE){
//                     let balance = a?.APPROVED_AMOUNT_FOR_DISTURBED - a?.AMOUNT_AVAILABLE
//                     let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                     let formatted = formatNumber(balance)
//                     return `${currencySymbol}${formatted}`  
//                     }else{
//                         return ''
//                     } 
//             }
//         },

//         // {data: 'ADDITIONAL_DETAILS'},

//         {
//             data: (a) => {
//                 return a?.CERTIFICATE_STATUS == 'pending' ? `
//                 <div class="badge badge-pill text-white text-capitalize badge-warning">
//                     ${a?.CERTIFICATE_STATUS}
//                 </div>` :  
//                 a?.CERTIFICATE_STATUS == 'approved' ?  `
//                 <div class="badge badge-pill text-white text-capitalize badge-info">
//                     ${a?.CERTIFICATE_STATUS}
//                 </div>` :  
//                 a?.CERTIFICATE_STATUS == 'disapproved' ?  `
//                 <div class="badge badge-pill text-white text-capitalize badge-danger">
//                     ${a?.CERTIFICATE_STATUS}
//                 </div>` :
//                 a?.CERTIFICATE_STATUS == 'confirmed' ?
//                 `<div class="badge badge-pill text-white text-capitalize badge-orange">
//                         ${a?.CERTIFICATE_STATUS}
//                     </div>`:
//                      `<div class="badge badge-pill text-white text-capitalize badge-success">
//                         ${a?.CERTIFICATE_STATUS}
//                     </div>`
//             }
//         },
//         {
//             data: (a) => {
//                 return moment(a?.CREATED_AT).format(pagesText.full_date)
//             }
//         },
//         {
//             data: (a) => {
//                 return `
//                         <a style="cursor: pointer" data-id=${a?.ID} class="btn-sm btn-primary certificate-view-details">View Details</a>
//                         `
//             },
//             responsivePriority: 2
//         }
//     ]

//     generalDatatableConfig(data, 'NotapCertificatesTable', cols, 'certificates', [0, 1, 2, 3, 4,5], [4, 'desc'],'Certificates')

//     $(document).on("click", ".certificate-view-details", function () {
//         const r = $(this).attr("data-id")
//         let x = data.filter((item) => Number(item?.ID) === Number(r))
//         if (x.length > 0) {
//             setItems(x[0], 'view-details')
//         }
//     })

// }

export const historyDatatable = (data, setItems, currencies) => {
    const cols = [

        {data: 'CERTIFICATE_NUMBER'},

        {data: 'CERTIFICATE_DATE'},

        {data: 'CURRENCY'},
        
        // {data: 'AMOUNT_REQUEST'},
        {
            data: (a) => {
                let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
                let amountRequested = Number(a?.AMOUNT_REQUEST)?.toLocaleString(
                                'en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                    }
                              )
                return `${currencySymbol}${amountRequested}`
            }
        },
        {
            data: (a) => {
                if(a?.APPROVED_AMOUNT_FOR_DISTURBED){
                    let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
                    let amountAvailable = Number(a?.APPROVED_AMOUNT_FOR_DISTURBED)?.toLocaleString(
                                    'en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                        }
                                )
                    return `${currencySymbol}${amountAvailable}`
                } else{
                    return ''
                }    
            }
        },
        // {
        //     data: (a) => {
        //         if(a?.APPROVED_AMOUNT_FOR_DISTURBED){
        //             let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
        //             let amountAvailable = Number(a?.APPROVED_AMOUNT_FOR_DISTURBED)?.toLocaleString(
        //                             'en-US', {
        //                                 minimumFractionDigits: 2,
        //                                 maximumFractionDigits: 2
        //                                 }
        //                         )
        //             return `${currencySymbol}${amountAvailable}`
        //         } else{
        //             return ''
        //         }    
        //     }
        // },
        {
            data: (a) => {
            return a?.WHT_RATE_PERCENTAGE ? `${a?.WHT_RATE_PERCENTAGE}%` : '' 
                
            }
        },

        // {data: 'AMOUNT_AVAILABLE'},
        {
            data: (a) => {
                if(a?.AMOUNT_AVAILABLE){
                    let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
                    let amountAvailable = Number(a?.AMOUNT_AVAILABLE)?.toLocaleString(
                                    'en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                        }
                                )
                    return `${currencySymbol}${amountAvailable}`
                } else{
                    return ''
                }    
            }
        },
        {
            data: (a) => {
                if(a?.AMOUNT_AVAILABLE){
                    let balance = a?.AMOUNT_REQUEST - a?.AMOUNT_AVAILABLE
                    let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
                    let formatted = formatNumber(balance)
                    return `${currencySymbol}${formatted}`  
                    }else{
                        return ''
                    } 
            }
        },
        {
            data: 'CONTACT_NAME'
        },
        {
            data: 'CONTACT_EMAIL'
        },
        {
            data: 'CONTACT_PHONE'
        },

        // {data: 'ADDITIONAL_DETAILS'},

        {
            data: (a) => {
                return a?.CERTIFICATE_STATUS == 'pending' ? `
                <div class="badge badge-pill text-white text-capitalize badge-warning">
                    ${a?.CERTIFICATE_STATUS}
                </div>` :  
                a?.CERTIFICATE_STATUS == 'approved' ?  `
                <div class="badge badge-pill text-white text-capitalize badge-info">
                    ${a?.CERTIFICATE_STATUS}
                </div>` :  
                a?.CERTIFICATE_STATUS == 'disapproved' ?  `
                <div class="badge badge-pill text-white text-capitalize badge-danger">
                    ${a?.CERTIFICATE_STATUS}
                </div>` :a?.CERTIFICATE_STATUS == 'confirmed' ?
                `<div class="badge badge-pill text-white text-capitalize badge-orange">
                        ${a?.CERTIFICATE_STATUS}
                    </div>` :a?.CERTIFICATE_STATUS == 'disbursed' ?
                `<div class="badge badge-pill text-white text-capitalize badge-success">
                        ${a?.CERTIFICATE_STATUS}
                    </div>`:
                     `<div class="badge badge-pill text-white text-capitalize badge-danger">
                        ${a?.CERTIFICATE_STATUS}
                    </div>`
            }
        },
        {
            data: (a) => {
                return convertDateTime(a.CREATED_AT, pagesText.full_date)
            }
        },
        // {
        //    data: (a) => {
        //         return `
        //                 <a style="cursor: pointer" data-id=${a?.ID} class="btn-sm btn-primary certificate-view-details">View Details</a>
        //                 `
        //     },
        //     responsivePriority: 2
        // }
    ]

    generalDatatableConfig(data, 'historyTable', cols, 'History', [0, 1, 2, 3, 4,5], [4, 'desc'],'History')

    $(document).on("click", ".certificate-view-details", function () {
        const r = $(this).attr("data-id")
        let x = data.filter((item) => Number(item?.ID) === Number(r))
        if (x.length > 0) {
            setItems(x[0], 'view-details')
        }
    })

}

export const digitalLetterDatatable = (data, setItems, shouldShow, userEmail, letterStatus) => {
    const cols = [
         {
            data:  (a) =>{
                return `
                        <button data-id=${a?.ID} class='p-0 text-primary letter-view-details'>
                            <i style="font-size: 1.2rem;" class="mdi mdi-plus-circle mr-1"></i>
                        </button>
                    `;
            }
        },
        {
            data: 'SENDER_ROLE_TEXT'
        },
        {
            data: (letter) => getLetterHistoryUserName(letter),
        },

        // {data: 'COMMENTS'},
        {
            data:  (a) =>{
                if(a?.COMMENTS && a?.COMMENTS != '<p><br></p>' && a?.COMMENTS != ''){
                    return `
                    <div class='text-wrap'>
                    ${a?.COMMENTS}
                    </div>`
                }else{
                    return 'N/A'
                }
            }
        },
        {
            data: (a) => {
                return convertDateTime(a.CREATED_AT, pagesText.full_date);
            }
        },
        // {
        //     data: (a) => {
        //         return ( 
        //             (userEmail == a?.RECEIVER_ID)? (
        //              `
        //                 <a style="cursor: pointer" data-id=${a?.ID} class="btn-sm btn-primary letter-edit-eval">Evaluate Letter</a>
        //                 <a style="cursor: pointer" data-id=${a?.ID} class="btn-sm btn-primary letter-send-eval">Send</a>
        //                 `
        //             ) : (
        //                 `
        //                 N/A
        //                 `
        //             ) 
        //         )    
        //     },
        //     responsivePriority: 2
        // }
    ]

    generalDatatableConfig(data, 'digitalLetterTable', cols, 'Digital Letter', [0, 1, 2], [0, 'desc'],'Digital Letter')

    // $(document).on("click", ".letter-edit-eval", function () {
    //     const r = $(this).attr("data-id")
    //     let x = data.filter((item) => Number(item?.ID) === Number(r))
    //     if (x.length > 0) {
    //         setItems(x[0], 'edit-eval')
    //     }
    // })

    // $(document).on("click", ".letter-send-eval", function () {
    //     const r = $(this).attr("data-id")
    //     let x = data.filter((item) => Number(item?.ID) === Number(r))
    //     if (x.length > 0) {
    //         setItems(x[0], 'send-eval')
    //     }
    // })

    $(document).on("click", ".letter-view-details", function () {
        const r = $(this).attr("data-id")
        let x = data.filter((item) => Number(item?.ID) === Number(r))
        if (x.length > 0) {
            setItems(x[0], 'letter-details')
        }
    })
}


// export const searchResultDatatable = (data, setItems, currencies) => {
//     const cols = [

//         {data: 'CERTIFICATE_NUMBER'},

//         {data: 'CERTIFICATE_DATE'},

//         // {data: 'CURRENCY'},
        
//         // {data: 'AMOUNT_REQUEST'},
//         {
//             data: (a) => {
//                 let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                 let amountRequested = Number(a?.AMOUNT_REQUEST)?.toLocaleString(
//                                 'en-US', {
//                                     minimumFractionDigits: 2,
//                                     maximumFractionDigits: 2
//                                     }
//                               )
//                 return `${currencySymbol}${amountRequested}`
//             }
//         },
//         {
//             data: (a) => {
//                 if(a?.APPROVED_AMOUNT_FOR_DISTURBED){
//                     let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                     let amountAvailable = Number(a?.APPROVED_AMOUNT_FOR_DISTURBED)?.toLocaleString(
//                                     'en-US', {
//                                         minimumFractionDigits: 2,
//                                         maximumFractionDigits: 2
//                                         }
//                                 )
//                     return `${currencySymbol}${amountAvailable}`
//                 } else{
//                     return ''
//                 }    
//             }
//         },
//         {
//             data: (a) => {
//             return a?.WHT_RATE_PERCENTAGE ? `${a?.WHT_RATE_PERCENTAGE}%` : '' 
                
//             }
//         },

//         // {data: 'AMOUNT_AVAILABLE'},
//         {
//             data: (a) => {
//                 if(a?.AMOUNT_AVAILABLE){
//                     let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                     let amountAvailable = Number(a?.AMOUNT_AVAILABLE)?.toLocaleString(
//                                     'en-US', {
//                                         minimumFractionDigits: 2,
//                                         maximumFractionDigits: 2
//                                         }
//                                 )
//                     return `${currencySymbol}${amountAvailable}`
//                 } else{
//                     return ''
//                 }    
//             }
//         },
//         {
//             data: (a) => {
//                 if(a?.AMOUNT_AVAILABLE){
//                     let balance = a?.APPROVED_AMOUNT_FOR_DISTURBED - a?.AMOUNT_AVAILABLE
//                     let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                     let formatted = formatNumber(balance)
//                     return `${currencySymbol}${formatted}`  
//                     }else{
//                         return ''
//                     } 
//             }
//         },

//         // {data: 'ADDITIONAL_DETAILS'},

//         {
//             data: (a) => {
//                 return a?.CERTIFICATE_STATUS == 'pending' ? `
//                 <div class="badge badge-pill text-white text-capitalize badge-warning">
//                     ${a?.CERTIFICATE_STATUS}
//                 </div>` :  
//                 a?.CERTIFICATE_STATUS == 'approved' ?  `
//                 <div class="badge badge-pill text-white text-capitalize badge-info">
//                     ${a?.CERTIFICATE_STATUS}
//                 </div>` :  
//                 a?.CERTIFICATE_STATUS == 'disapproved' ?  `
//                 <div class="badge badge-pill text-white text-capitalize badge-danger">
//                     ${a?.CERTIFICATE_STATUS}
//                 </div>` :a?.CERTIFICATE_STATUS == 'confirmed' ?
//                 `<div class="badge badge-pill text-white text-capitalize badge-orange">
//                         ${a?.CERTIFICATE_STATUS}
//                     </div>`:
//                      `<div class="badge badge-pill text-white text-capitalize badge-success">
//                         ${a?.CERTIFICATE_STATUS}
//                     </div>`
//             }
//         },
//         {
//             data: (a) => {
//                 return moment(a?.CREATED_AT).format(pagesText.full_date)
//             }
//         },
//         {
//            data: (a) => {
//                 return `
//                         <a style="cursor: pointer" data-id=${a?.ID} class="btn-sm btn-primary certificate-view-details">View Details</a>
//                         `
//             },
//             responsivePriority: 2
//         }
//     ]


//     generalDatatableConfig(data, 'searchResultTable', cols, 'results', [0, 1, 2, 3, 4,5], [4, 'desc'],'Certificates')

//     $(document).on("click", ".certificate-view-details", function () {
//         const r = $(this).attr("data-id")
//         let x = data.filter((item) => Number(item?.ID) === Number(r))
//         if (x.length > 0) {
//             setItems(x[0], 'view-details')
//         }
//     })

// }

const generalDatatableConfig = (data, table_id, cols, table_name, exportRow = [0, 1, 2], ordering = [0, 'desc'],pageTitle,btnName=`${pagesText.admin_export_text}`) => {
    let isLandScape = true
    let exportTitle = `<img src="${strText.app_logo}" alt="" height="90"/>`
    let exportOptionsIndex = exportRow

    let fromDate = ''
    let toDate = ''
    let total = 0
    let other_title = table_name ?? 'notap'

    $(document).ready(function () {
        let idInit = $(`#${table_id}`)
        idInit.DataTable().clear().destroy()
        idInit.DataTable({
            data: data,
            info: true,
            dom: "<'row'<'col-sm-12'B>>" +
                  "<'row align-items-center'<'col-sm-12 col-md-6'l><'pt-2 pt-md-0 col-sm-12 col-md-6'f>>" +
                  "<'row dt-row'<'col-sm-12'tr>>" +
                  "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
            lengthChange: true,
            lengthMenu: [
                [5, 10, 15, -1],
                [5, 10, 15, "All"],
            ],
            language: {
                paginate: {
                    previous: `
                                <span aria-hidden="true" class="mdi mdi-chevron-left mr-1"></span> Prev
                                <span class="sr-only">Previous</span>`,
                    next: `Next
                            <span aria-hidden="true" class="mdi mdi-chevron-right ml-1"></span>
                            <span class="sr-only">Next</span>`,
                },
                search: "_INPUT_",
                searchPlaceholder: "Search...",
            },
            columns: cols,
            responsivePriority: 1,
            responsive: true,
            // order: [ordering],
            ordering: false,
            pageLength: 10,
            buttons: [
                {
                    extend: "print",
                    text: btnName,
                    footer: false,
                    orientation: isLandScape ? "landscape" : "portrait",
                    pageSize: isLandScape ? "LEGAL" : "A4",
                    exportOptions: {
                        columns: exportOptionsIndex,
                    },
                    title: exportTitle,
                    className: "btn btn-primary btn-sm mx-1",
                    header: true,
                    messageTop: `<table style="border-bottom:1px solid black;width:100% !important;text-align:center;margin-bottom: 30px;margin-top: 30px;">
                                        <tr>
                                            <th colspan="3" style="align-content: center; align-items:center;font-size: 2rem;"> ${pageTitle}</th>
                                            <th>  </th>
                                            <th>   </th>
                                        </tr>
                                        
                                    </table>`,
                    messageBottom: ``,
                    filename: `${other_title}_data_for_${fromDate}_${toDate}_`,
                },
            ],
        })
    })
}

// export const certicatesDatatable = (data, setItems, currencies) => {
//     const cols = [

//         {data: 'CERTIFICATE_NUMBER'},

//         {data: 'CERTIFICATE_DATE'},

//         {data: 'CURRENCY'},
        
//         // {data: 'AMOUNT_REQUEST'},
//         {
//             data: (a) => {
//                 let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                 let amountRequested = Number(a?.AMOUNT_REQUEST)?.toLocaleString(
//                                 'en-US', {
//                                     minimumFractionDigits: 2,
//                                     maximumFractionDigits: 2
//                                     }
//                               )
//                 return `${currencySymbol}${amountRequested}`
//             }
//         },

//         // {data: 'AMOUNT_AVAILABLE'},
//         {
//             data: (a) => {
//                 let currencySymbol = getCurrencySymbol(currencies, a?.CURRENCY)
//                 let amountAvailable = Number(a?.AMOUNT_AVAILABLE)?.toLocaleString(
//                                 'en-US', {
//                                     minimumFractionDigits: 2,
//                                     maximumFractionDigits: 2
//                                     }
//                               )
//                 return `${currencySymbol}${amountAvailable}`
//             }
//         },

//         {data: 'ADDITIONAL_DETAILS'},

//         {
//             data: (a) => {
//                 return a?.CERTIFICATE_STATUS == 'pending' ? `
//                 <div class="badge badge-pill text-white text-capitalize badge-warning">
//                     ${a?.CERTIFICATE_STATUS}
//                 </div>` :  
//                 a?.CERTIFICATE_STATUS == 'proceed to disbursed' ?  `
//                 <div class="badge badge-pill text-white text-capitalize badge-info">
//                     ${a?.CERTIFICATE_STATUS}
//                 </div>` :
//                      `<div class="badge badge-pill text-white text-capitalize badge-success">
//                         ${a?.CERTIFICATE_STATUS}
//                     </div>`
//             }
//         },
//         {
//             data: (a) => {
//                 return moment(a?.CREATED_AT).format(pagesText.full_date)
//             }
//         },
//         {
//             data: (a) => {
//                 return `<div class="dropdown">
//                             <a class="dropdown-toggle icon-burger-mini" role="button" id="dropdownMenuLink"
//                                 data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static">
//                                 <i class="mdi mdi-dots-vertical"></i>
//                             </a>

//                             <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
//                                 <a style="cursor: pointer" data-id=${a?.ID} class="dropdown-item certificate-view-details">View Details</a>
//                                 <a style="cursor: pointer" data-id=${a?.ID} class="dropdown-item certificate-add-comment">Add Comment</a>
//                             </div>
//                         </div>`
//             },
//             responsivePriority: 2
//         }
//     ]

//     generalDatatableConfig(data, 'certificatesTable', cols, 'certificates', [0, 1, 2, 3, 4,5], [4, 'desc'],'Certificates')

//     // $(document).on("click", ".dropdown", function () {
//     //     const r = $(this).attr("data-toggle")
//     //     let x = data.filter((item) => Number(item.user_id) === Number(r))
//     //     if (x.length > 0) {
//     //         setItems(x[0])
//     //     }
//     // })

//     $(document).on("click", ".certificate-view-details", function () {
//         const r = $(this).attr("data-id")
//         let x = data.filter((item) => Number(item?.ID) === Number(r))
//         if (x.length > 0) {
//             setItems(x[0], 'view-details')
//         }
//     })

//     $(document).on("click", ".certificate-add-comment", function () {
//         const r = $(this).attr("data-id")
//         let x = data.filter((item) => Number(item?.ID) === Number(r))
//         if (x.length > 0) {
//             setItems(x[0], 'add-comment')
//         }
//     })

// }